export default {
  apiNotAvailable: 'NPM API niedostępne',
  systemKnown: 'System znany dla NPM API',
  systemUnknown: 'System nieznany dla NPM API',
};
